import { JsonObject, JsonProperty } from 'json2typescript';

import { MediaInfo } from '../media/media-info';

/**
 * å»é¢èªå®ä¹logo(ç¨äºæ¿æ¢å·¦ä¸è§512logo)ç¸å³ä¿¡æ¯
 */
@JsonObject
export class TenantLogo {
  /**
   * æ¯å¦å¯ç¨å»é¢èªå®ä¹logo
   */
  @JsonProperty('active', Boolean)
  active: boolean = undefined;

  /**
   * å·ä½logoå¾ççåªä½èµæºä¿¡æ¯
   */
  @JsonProperty('mediaInfo', MediaInfo)
  mediaInfo: MediaInfo = undefined;
}
